import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { takePendingOAuthReturn } from "@/lib/oauthReturnPath";

/**
 * After a brand-new user finishes signup (checkout + magic link), send them
 * back to the Claude.ai consent screen they started from.
 */
export function PendingOAuthResumer() {
  const { user } = useAuth();
  const { pathname } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!user) return;
    if (pathname.startsWith("/.lovable/oauth/consent")) {
      takePendingOAuthReturn(); // already there — clear it
      return;
    }
    if (pathname.startsWith("/auth")) return; // Auth page handles its own returnTo
    const pending = takePendingOAuthReturn();
    if (pending) navigate(pending, { replace: true });
  }, [user, pathname, navigate]);

  return null;
}
